import React from "react";
// Import only this one icon instead of the whole Images map so the
// production bundle does not carry every image in the app.
import ic_accessDenied from "../assets/images/access-denied.png";

const NetworkErrorScreen = ({ onRetry }) => {
  return (
    <div style={styles.container}>
      <img src={ic_accessDenied} alt="Network error" height={200} />
      <h1 style={{ marginTop: 30 }}>Network Error</h1>
      <p style={{ marginTop: 12 }}>
        It seems you are offline or there is an issue with the network.
      </p>

      {/* You can add more options or navigation buttons here */}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  },
  retryButton: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "20px",
  },
};

export default NetworkErrorScreen;
